<script type="text/babel">
  import Base from './BaseMonodimentionalChart.vue'
  import Chart from 'chart.js'

  export default Base.extend({
    name: "PolarChart",
    methods: {
      customBuilder: function (context) {
        return new Chart.PolarArea(context, this.config);
      },
      getChartType: function () {
        return "polar";
      }
    }
  })
</script>



// WEBPACK FOOTER //
// PolarChart.vue?2d5d0e01